// Shared Realtime Database key names.
//
// Three clients read and write the same nodes — this app, the serverless
// functions, and the iOS app — so the strings live in one constant per client
// and are never spelled out at the point of use. Changing a value here means
// migrating every stored record, so the three copies must be changed together
// and deployed together.
//
// Mirror of api/_lib/dbKeys.js and ios/Prisma Budget/Prisma Budget/DBKeys.swift;
// the three must agree.
export const CONNECTIONS_NODE = 'bankConnections';

// Per-transaction: the provider's own id for the row, and the connection it
// arrived through.
export const BANK_TX_ID = 'bankTxId';
export const BANK_TX_CONNECTION_ID = 'bankConnectionId';

// `source` values that mark a transaction as bank-imported rather than manual
// or CSV.
export const BANK_TX_SOURCES = ['plaid'];
